import {
  FaCarSide,
  FaClipboardList,
  FaFileMedicalAlt,
  FaHandsHelping,
  FaPills,
  FaUserClock,
  FaUserNurse,
  FaUtensils,
} from 'react-icons/fa';

export const coreServices = [
  {
    title: 'Personal care and hygiene assistance',
    icon: FaUserNurse,
  },
  {
    title: 'Medication reminders and monitoring',
    icon: FaPills,
  },
  {
    title: 'Meal preparation and feeding support',
    icon: FaUtensils,
  },
  {
    title: 'Transportation and community errands',
    icon: FaCarSide,
  },
];

export const intakeSteps = [
  {
    title: 'Initial conversation',
    text: 'Share participant goals, safety concerns, schedule preferences, and current support needs.',
    icon: FaClipboardList,
  },
  {
    title: 'Care and eligibility review',
    text: 'We review available benefit pathways, required documents, and practical service options.',
    icon: FaFileMedicalAlt,
  },
  {
    title: 'Personalized care plan',
    text: 'A plan is built around daily routines, mobility level, communication needs, and family input.',
    icon: FaHandsHelping,
  },
  {
    title: 'Service kickoff and updates',
    text: 'Care begins and your plan is adjusted as participant needs and goals change over time.',
    icon: FaUserClock,
  },
];

export const eligibilityNotes = [
  'Programs often require a documented need for in-home support and periodic reassessment.',
  'Coverage can vary by program rules, care type, and provider requirements.',
  'Families should request a clear list of covered services, visit limits, and any out-of-pocket costs.',
];

export const faqs = [
  {
    question: 'How quickly can services begin?',
    answer:
      'Start time depends on referral readiness and required documentation. Our team can usually provide a clear onboarding timeline after your first call.',
  },
  {
    question: 'Can care plans be customized for language and culture preferences?',
    answer:
      'Yes. We design plans with participant and family preferences in mind, including communication style, routines, and cultural considerations.',
  },
  {
    question: 'What should families prepare before the intake call?',
    answer:
      'Gather medication lists, emergency contacts, recent provider notes, daily routine details, and any existing assessments.',
  },
  {
    question: 'Do you help families understand covered vs non-covered services?',
    answer:
      'Absolutely. We walk through typical service categories and help you ask the right questions during enrollment and care planning.',
  },
];
